import { useNavigate } from "react-router-dom";
import { CompositeEditor } from "@/components/features/talent/Composites/CompositeEditor";

export function EditCompositePage() {
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="flex min-h-screen w-full flex-col">
      <CompositeEditor mode="edit" onCancel={handleCancel} />
    </div>
  );
}
